// @ts-nocheck
import React from 'react'
import AssetGraph from '../../components/AssetGraphComponents/AssetGraph'

// This component is responsible for rendering the graph section of the Asset Page. It receives the selected asset and various 
// control registration functions as props, and uses the AssetGraph component to display the graph based on the selected asset's data.
interface AssetPageGraphProps {
  // The selected asset whose data will be displayed in the graph.
  selectedAsset?: unknown | null
  onRegisterDownload?: (controls: unknown) => void
  onRegisterForecastControls?: (controls: unknown) => void
  onRegisterGraphControls?: (controls: unknown) => void
  onRegisterViewControls?: (controls: unknown) => void
}
const AssetPageGraph: React.FC<AssetPageGraphProps> = ({
  //
  selectedAsset,
  onRegisterDownload,
  onRegisterForecastControls,
  onRegisterGraphControls,
  onRegisterViewControls,
}) => { 
  // The component uses the AssetGraph component to display the graph, passing down the necessary props and control registration functions.
  return (
    <div className="rounded-[8px] border border-eai-bg-lt2 bg-white flex flex-col min-h-0 h-[700px]">
      <div className="relative flex-1 min-h-0 overflow-hidden">
        <AssetGraph
          selectedAsset={selectedAsset}
          onRegisterDownload={onRegisterDownload}
          onRegisterForecastControls={onRegisterForecastControls}
          onRegisterGraphControls={onRegisterGraphControls}
          onRegisterViewControls={onRegisterViewControls}
          disableMapView
          hideHeader
          hideGraphControls
          hideContainer
        />
      </div>
    </div>
  )
}
export default AssetPageGraph
